import { Link } from 'react-router';
import cn from 'classnames';

import { ArrowIcon } from '../Icons';

import style from './Button.module.scss';

export default function Button({ to, href, variant = 'primary', size, arrow = false, className, children, ...rest }) {
  const classes = cn(style.btn, style[variant], size && style[size], className);
  const content = (
    <>
      {children}
      {arrow && <ArrowIcon className={style.arr} />}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={classes}
        {...rest}
      >
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        {...rest}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type='button'
      className={classes}
      {...rest}
    >
      {content}
    </button>
  );
}
